import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en/messages.json";
import hi from "./locales/hi/messages.json";
import es from "./locales/es/messages.json";
import de from "./locales/de/messages.json";
import pt from "./locales/pt/messages.json";
import bn from "./locales/bn/messages.json";

i18next.use(LanguageDetector).init({
  // debug: true,
  debug: process.env.NODE_ENV !== "development" ? true : false,
  resources: {
    en,
    hi,
    es,
    de,
    pt,
    bn,
  },
});

export default i18next;
